import React from 'react';
import Icon from '@ant-design/icons';
import { IconComponentProps } from '@ant-design/icons/lib/components/Icon';

export const AIStarsIcon = (props: IconComponentProps) => {

  const AIStarsSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={props.width} height={props.height}>
      <path fill={'url(#starsGradient)'}
            d="m18 3 1.5-3L21 3l3 1.5L21 6l-1.5 3L18 6l-3-1.5L18 3ZM6 9l3-6 3 6 6 3-6 3-3 6-3-6-6-3 6-3Zm13.5 6 1.5 3 3 1.5-3 1.5-1.5 3-1.5-3-3-1.5 3-1.5 1.5-3Z"/>
      <defs>
        <linearGradient id="starsGradient" x1="3" x2="24" y1="15" y2="6" gradientUnits="userSpaceOnUse">
          <stop offset=".13" stopColor="#1D4A9B"/>
          <stop offset="1" stopColor="#55C2EF"/>
        </linearGradient>
      </defs>
    </svg>
  );

  return <Icon component={AIStarsSvg} {...props} />;
};
